// Centralized API helper that fails gracefully when the backend is missing
// (e.g. Netlify deploy without REACT_APP_BACKEND_URL set, or backend down).
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : null;
export const API_AVAILABLE = Boolean(BACKEND_URL);

// GET request, returns null if backend not configured or response is not JSON.
// Use `expectArray` to enforce that the response data is an array; otherwise null is returned.
export async function apiGet(path, { expectArray = false } = {}) {
  if (!API_BASE) return null;
  try {
    const res = await axios.get(`${API_BASE}${path}`);
    const data = res?.data;
    if (expectArray && !Array.isArray(data)) return null;
    if (!expectArray && typeof data !== "object") return null;
    return data;
  } catch {
    return null;
  }
}

export async function apiPost(path, body) {
  if (!API_BASE) {
    const err = new Error("Backend not configured");
    err.code = "NO_BACKEND";
    throw err;
  }
  const res = await axios.post(`${API_BASE}${path}`, body);
  return res.data;
}
